/** Grid fragment shader. */

/** @todo Use a better setup than this, for tidier ongoing mapping tests. */
#define test_off 0
#define test_p2g 1
#define test_draw 2
#ifndef test
  #define test test_off
#endif

#ifdef GL_EXT_draw_buffers
  #extension GL_EXT_draw_buffers : require
#endif

precision highp float;

grid_useSamples

#ifdef grid_output_motionFull
  grid_useReads_motionFull
#endif
#ifdef grid_output_motionBase
  grid_useReads_motionBase
#endif

/** @todo `gl-gpgpu` should skip passes with no output; here for mass. */
#if defined(grid_output_motionFull) || defined(grid_output_motionBase)
  #ifdef grid_splits
    uniform sampler2D grid_states[grid_splits];
  #else
    uniform sampler2D grid_states;
  #endif

  uniform float grid_stepNow;
#endif
#if defined(grid_output_motionFull)
  uniform vec4 grid_stateShape;
#endif

#if defined(grid_output_motionFull) || defined(grid_output_motionBase)
  uniform vec3 g;
  uniform float dt;

  #ifdef rescale_mass
    uniform vec2 rescaleMass;
  #else
    const float rescaledMass = 1.0;
  #endif
  #ifdef rescale_motion
    uniform vec2 rescaleMotion;
  #else
    const float rescaledMotion = 1.0;
  #endif

  #pragma glslify: gt = require(glsl-conditionals/when_gt);

  #pragma glslify: offsetUV = require(@epok.tech/gl-gpgpu/src/lookup/offset-uv);

  #if defined(rescale_mass) || defined(rescale_motion)
    #pragma glslify: exponent = require(../vector/exponent);
  #endif
#endif
#if defined(grid_output_motionFull)
  uniform vec4 boundsIn;
  uniform float boundsHit;

  #pragma glslify: lt = require(glsl-conditionals/when_lt);
  #pragma glslify: ge = require(glsl-conditionals/when_ge);
#endif

varying vec2 grid_uv;

const vec2 v1 = vec2(1);
const vec2 v0 = v1*0.0;

#if defined(grid_output_motionFull)
  const float hitStop = 0.0;
  const float hitBack = 1.0;
  const float hitBounce = 2.0;
#endif

void main() {
  #if defined(grid_output_motionFull) || defined(grid_output_motionBase)
    #ifdef readMass
    #elif defined(grid_output_motionFull)
      #define readMass grid_reads_motionFull_mass
    #elif defined(grid_output_motionBase)
      #define readMass grid_reads_motionBase_mass
    #endif

    grid_tapState(offsetUV(grid_uv, grid_stateShape.xy));
    // grid_tapState(grid_uv);

    #if test == test_p2g
      // for(int t = 0; t < grid_textures; ++t) { gl_FragData[t] = grid_data[t]; }
      gl_FragData[0] = grid_data[0];
      return;
    #endif

    #ifdef rescale_mass
      float rescaledMass = exponent(rescaleMass);
    #endif
    #ifdef rescale_motion
      float rescaledMotion = exponent(rescaleMotion);
    #endif

    float mass = rescaledMass*grid_data[readMass].grid_channels_mass;
    float on = gt(mass, 0.0);
    float massScale = 1.0/mix(1.0, mass, on);
  #endif

  #ifdef grid_output_motionFull
    vec2 motionFull = rescaledMotion*
      grid_data[grid_reads_motionFull_motionFull].grid_channels_motionFull;

    motionFull *= massScale;

    /** External forces. */
    motionFull += normalize(g.xy-mix(-v1, v1, grid_uv))*g.z*dt;

    /** Boundaries. */

    vec2 at = grid_uv*grid_stateShape.xy;

    vec4 boundsTo = vec4(boundsIn.xy, boundsIn.zw+grid_stateShape.xy)-at.xyxy;

    vec4 boundsOut = vec4(gt(boundsTo.xy, v0)*lt(motionFull, v0),
      lt(boundsTo.zw, v0)*gt(motionFull, v0));

    vec2 moveStop = v0;
    vec2 moveBack = (boundsTo.xy*boundsOut.xy)+(boundsTo.zw*boundsOut.zw);
    vec2 moveBounce = -motionFull;
    float geStop = ge(boundsHit, hitStop);
    float geBack = ge(boundsHit, hitBack);
    float geBounce = ge(boundsHit, hitBounce);
    vec2 moveHit = motionFull;

    moveHit = mix(moveHit, moveStop, geStop);
    moveHit = mix(moveHit, moveBack, geBack);
    moveHit = mix(moveHit, moveBounce, geBounce);
    motionFull = mix(motionFull, moveHit, boundsOut.xy+boundsOut.zw);

    // grid_output_motionFull = (on*motionFull)/rescaledMotion;
    grid_output_motionFull = motionFull/rescaledMotion;
  #endif
  #ifdef grid_output_motionBase
    vec2 motionBase = rescaledMotion*
      grid_data[grid_reads_motionBase_motionBase].grid_channels_motionBase;

    // grid_output_motionBase = (on*motionBase*massScale)/rescaledMotion;
    grid_output_motionBase = (motionBase*massScale)/rescaledMotion;
  #endif
}
